



































































import { Component, Vue, Watch, Emit, Prop } from 'vue-property-decorator';
import CommonModalHeader from '@/components/common/CommonModalHeader.vue';
import DocumentIcon from '@/components/documents/DocumentIcon.vue';
import CommonButton from '@/components/common/CommonButton.vue';

@Component({
  components: {
    CommonModalHeader,
    DocumentIcon,
    CommonButton,
  },
})
export default class AddDirectoryModal extends Vue {
  @Prop(Boolean) public isOpenAddDirectoryModal!: boolean;
  private modalHeaderTitle: string = 'ドキュメントグループを追加します';
  private modalMode: string = 'add';
  private rool: Array<string> = ['管理者', '一般ユーザー'];
  // モーダルのヘッダーに閉じるボタンを表示させるためのwidth
  private modalHeaderWidth: string = '550px';
  private documentAvatarSize: number = 50;
  private documentAvatarColor: string = '#4384f3';
  private documentIconSize: number = 27;
  private documentIconColor: string = 'white';
  private commonButtonColorCreate: string = '#4384f3';

  @Emit('closeAddDirectoryModal')
  private closeAddDirectoryModal(): void {
    this.isOpenAddDirectoryModal = false;
  }
}
